import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers';
import { TextField, InputLabel } from '@mui/material';

export default function CustomDatePicker({
    maxDate,
    SelectedDate,
    handleDateChange,
    Label,
    name,
    variant,
    className,
    size = "small",
    isRequired,
    minDate,
    views,
    error,
    customStyles, // Add customStyles for full control
}) {
    return (
        <>
            <div className={`${className} mt-2`}>
                <InputLabel
                    id="demo-simple-select-label"
                    sx={{ fontSize: "11px", color: "#000", fontWeight: "600" }}
                    className='black-color'
                >
                    {Label}
                    {isRequired && <span className="text-danger"> *</span>}
                </InputLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        maxDate={maxDate}
                        views={views}
                        minDate={minDate}
                        inputFormat="MM/dd/yyyy"
                        value={SelectedDate}
                        onChange={handleDateChange}
                        onBlur={handleDateChange}
                        name={name}
                        className='black-color'
                        renderInput={(params) => (
                            <TextField
                                variant={variant || "standard"}
                                className='black-color'
                                {...params}
                                sx={{
                                    width: "100%",
                                    "& .MuiInputBase-input": {
                                        height: "1.5em !important",
                                        fontSize: "0.875rem",
                                        padding: "10px 12px",
                                    }
                                }}
                            />
                        )}
                    />
                </LocalizationProvider>
                {error && <div className="font-11" style={{ color: 'red' }}>{error}</div>}
            </div>
        </>
    );
}
